import type { RedcatAnalyticsStore } from '../types/store';
import { SigninTrackEventName } from '../types/signin';
import type { SigninTrackEvent } from '../types/events/track';

export const trackSigninStarted = (
  track: RedcatAnalyticsStore['track'],
  { entryPoint }: { entryPoint: string },
) => {
  const event: SigninTrackEvent = {
    name: SigninTrackEventName.Started,
    properties: {
      entry_point: entryPoint,
    },
  };

  track(event);
};
